import React, { useState } from 'react';
import classname from 'classnames';
import { Button, Popup } from 'zarm';
import { ActionProps, BaseWidgetProps } from 'components/utils/type';
import LockScroll from '../lockScroll';

/**
 * 容错处理
 * fallback
 * width={200}
 * height={200}
 * ionError
 * ionImgDidLoad
 * ionImgWillLoad
 */

export interface ImageProps extends BaseWidgetProps {
  alt?: string;
  href?: string;
  bigImage?: string;
  align?: 'left' | 'center' | 'right';
  fallback?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (param?: any) => {};
  prefixCls?: string;
  action?: ActionProps;
  id?: string | number;
}

const UImage = (props: ImageProps) => {
  const {
    prefixCls = 'crm-image',
    href,
    alt = '',
    align = 'left',
    style,
    // fallback,
    className,
    _crengine,
    action,
    onClick,
    id,
    bigImage,
  } = props;
  const [visible, setVisible] = useState(false);
  const { action: waction } = _crengine || {};

  const cls = classname(prefixCls, `${prefixCls}-${align}`, className);

  if (!href) {
    return (
      <div className={`${prefixCls}-empty`}>
        请设置图片地址
      </div>
    );
  }

  const imageProps: any = {};

  if (typeof id !== 'undefined') {
    imageProps.id = id;
  }

  const getInitImage = () => {
    setVisible(true);
  };

  return (
    <div
      {...imageProps}
      className={cls}
      onClick={(e) => {
        if (action && waction) {
          waction(action);
        }

        if (bigImage) {
          return getInitImage();
        }

        onClick && onClick(e);
      }}
    >
      <img style={style} src={href} alt={alt} />

      <LockScroll>
        <Popup
          visible={visible}
          direction="center"
          width="100%"
        >
          <div className="popup-box-img">
            <img className="popup-box-bigimage" src={bigImage} alt="" />
            <Button className="popup-box-close" onClick={() => setVisible(false)}>关闭</Button>
          </div>
        </Popup>
      </LockScroll>
    </div>
  );
};

export default UImage;
